import {
	checkStatusMsiFile,
	getDownloadMsiInstallerUrl,
} from '@Actions/implementation';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import { getValue } from '@Selectors';
import { FLAGS } from '@Types/flags';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface DeviceInstallerDownloadReturn {
	downloadMsiUrl: string;
	isDownloadMsiUrlMissing: boolean;
	isMsiInstallerInitialized: boolean;
	isMsiInstallerBuildRunning: boolean;
	isLatestBuildTooOld: boolean;
	isMsiBuildCreated: boolean;
}

const useDeviceInstallerDownload = (): DeviceInstallerDownloadReturn => {
	const dispatch = useDispatch();

	const {
		implementation: { msiInstaller },
	} = useSelector(getValue);

	const isMsiInstallerEnabled = useIsFeatureEnabled(
		FLAGS.MSI_INSTALLER_DOWNLOAD,
	) as unknown as boolean;
	const isGlobalMsiInstallerEnabled = useIsFeatureEnabled(
		FLAGS.IMPLEMENTATION_GLOBAL_MSI,
	) as unknown as boolean;

	useEffect(() => {
		if (isGlobalMsiInstallerEnabled || isMsiInstallerEnabled) {
			const params = { global: isGlobalMsiInstallerEnabled };
			dispatch(getDownloadMsiInstallerUrl(params));
		}
	}, [isMsiInstallerEnabled]);

	useEffect(() => {
		// ? build not completed
		if (
			!isGlobalMsiInstallerEnabled &&
			isMsiInstallerEnabled &&
			!msiInstaller?.buildStatus.buildComplete
		) {
			const params = { global: isGlobalMsiInstallerEnabled };
			dispatch(checkStatusMsiFile(params));
		}
	}, [isMsiInstallerEnabled, msiInstaller?.buildStatus.buildComplete]);

	const downloadMsiUrl = msiInstaller?.downloadUrl || '';
	const isMsiInstallerInitialized =
		msiInstaller?.status !== 'idle' && msiInstaller?.status !== 'pending';
	const isMsiInstallerBuildRunning =
		!msiInstaller?.buildStatus.buildComplete ||
		msiInstaller?.buildStatus.buildStatus === 'IN_PROGRESS';

	const buildTs = new Date(
		msiInstaller?.buildStatus.startTime || 1,
	).getTime();
	const tsDiff = Date.now() - buildTs;
	const isLatestBuildTooOld = tsDiff >= 1000 * 60 * 60 * 24 * 30; // ? 1 month
	const isDownloadMsiUrlMissing =
		!downloadMsiUrl && !isMsiInstallerBuildRunning;
	const isMsiBuildCreated = !!msiInstaller?.buildStatus.id;

	return {
		downloadMsiUrl,
		isMsiInstallerInitialized,
		isMsiInstallerBuildRunning,
		isLatestBuildTooOld: isLatestBuildTooOld,
		isDownloadMsiUrlMissing,
		isMsiBuildCreated: isMsiBuildCreated,
	};
};

export default useDeviceInstallerDownload;
